/** Canonical OneEthos request override headers (shared namespace across integrations). */
export const OE_HEADER_OAUTH_CLIENT_ID = 'x-oe-oauth-client-id' as const
export const OE_HEADER_OAUTH_CLIENT_SECRET = 'x-oe-oauth-client-secret' as const
export const OE_HEADER_OAUTH_CLIENT_ASSERTION = 'x-oe-oauth-client-assertion' as const
export const OE_HEADER_BASE_URL = 'x-oe-base-url' as const
export const OE_HEADER_ROUTING_ID = 'x-oe-routing-id' as const
export const OE_HEADER_INSTITUTION_ENVIRONMENT = 'x-oe-institution-environment' as const
export const OE_HEADER_VALID_CONSUMER_NAME = 'x-oe-valid-consumer-name' as const
export const OE_HEADER_VALID_CONSUMER_PRODUCT = 'x-oe-valid-consumer-product' as const
export const OE_HEADER_AUDIT_USER_ID = 'x-oe-audit-user-id' as const
export const OE_HEADER_AUDIT_WORKSTATION_ID = 'x-oe-audit-workstation-id' as const
export const OE_HEADER_INSTITUTION_ID = 'x-oe-institution-id' as const
export const OE_HEADER_MEMBER_NUMBER = 'x-oe-member-number' as const
export const OE_HEADER_SECURITY_CODE = 'x-oe-security-code' as const
export const OE_HEADER_MODEL_NUMBER = 'x-oe-model-number' as const
export const OE_HEADER_TENANT_ID = 'x-oe-tenant-id' as const
export const OE_HEADER_APPLICATION_ID = 'x-oe-application-id' as const
export const OE_HEADER_CONFIG_ID = 'x-oe-config-id' as const
export const OE_HEADER_ENTITY_ID = 'x-oe-entity-id' as const

export const OE_OVERRIDE_HEADERS = [
  OE_HEADER_OAUTH_CLIENT_ID,
  OE_HEADER_OAUTH_CLIENT_SECRET,
  OE_HEADER_OAUTH_CLIENT_ASSERTION,
  OE_HEADER_BASE_URL,
  OE_HEADER_ROUTING_ID,
  OE_HEADER_INSTITUTION_ENVIRONMENT,
  OE_HEADER_VALID_CONSUMER_NAME,
  OE_HEADER_VALID_CONSUMER_PRODUCT,
  OE_HEADER_AUDIT_USER_ID,
  OE_HEADER_AUDIT_WORKSTATION_ID,
  OE_HEADER_INSTITUTION_ID,
  OE_HEADER_MEMBER_NUMBER,
  OE_HEADER_SECURITY_CODE,
  OE_HEADER_MODEL_NUMBER,
  OE_HEADER_TENANT_ID,
  OE_HEADER_APPLICATION_ID,
  OE_HEADER_CONFIG_ID,
  OE_HEADER_ENTITY_ID
] as const

export type OeOverrideHeader = (typeof OE_OVERRIDE_HEADERS)[number]
